import axios from "axios";

import { getAuthHeader } from "@/services/user.service.js";

export { GetAllKeywords, GetKeyword, AddKeyword, UpdateKeyword, DeleteKeyword };

function GetAllKeywords(
  maxNumberOfItems,
  filter,
  selectedLanguage,
  onSuccess,
  onError,
) {
  var authHeader = getAuthHeader();

  var queryParameter = `?Language=${selectedLanguage}&MaxItems=${maxNumberOfItems}&Titel=${filter ? filter : ""}`;

  if (!selectedLanguage) {
    queryParameter = queryParameter + "&SearchLanguageIndependent=true";
  }

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + "/keywordsearch" + queryParameter,
      authHeader,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetKeyword(keyWordId, onSuccess, onError) {
  var authHeader = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/keywords/${keyWordId}`,
      authHeader,
    )
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function AddKeyword(keywordInformation, onSuccess, onError) {
  var authHeader = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/keywords`,
      keywordInformation,
      authHeader,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function UpdateKeyword(keywordInformation, keywordId, onSuccess, onError) {
  var authHeader = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + `/keywords/${keywordId}`,
      keywordInformation,
      authHeader,
    )
    .then((response) => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteKeyword(keywordId, onSuccess, onError) {
  var authHeader = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL + `/keywords/${keywordId}`,
      authHeader,
    )
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      onError(error);
    });
}
